<template>
  <div :class="classes">
    <div class="select-another-image">
      <div class="select-another-image__mask"/>
      <div
        v-if="frameInfo.IsFavorite"
        class="select-another-image__favorite-icon-wrapper"
      >
        <i class="v2-icon-favorite select-another-image__favorite-icon"/>
      </div>
      <a
        href="#"
        @click.prevent="$emit('image-click', imgClickData)"
      >
        <img
          :alt="frameInfo.FriendlyDisplayName"
          :src="frameInfo.Urls.SmallClean"
          class="select-another-image__image"
        >
      </a>
      <div class="select-another-image__modifications">
        <div
          v-if="numberRetouchingsApplied > 0"
          :title="enhancementsModificationTitle"
          class="select-another-image__modification select-another-image__modification--retouching"
        >
          {{ numberRetouchingsApplied }}
        </div>
        <div
          v-if="frameInfo.IsCropped"
          :title="contentfulText('custom-crop-label').Content"
          class="select-another-image__modification select-another-image__modification--crop"
        >
          <contentful-text :item="contentfulText('custom-crop-label')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentfulMixin from '@Shared/mixins/contentful'

export default {
  name: 'SelectPhotoModalFrameImage',
  mixins: [
    ContentfulMixin
  ],
  props: {
    frameInfo: { type: Object, default: null }
  },
  computed: {
    classes () {
      return {
        'select-another-grid-item': true,
        'select-another-grid-item--width-2': this.frameInfo.Orientation === 0 // 0 = horizontal
      }
    },
    imgClickData () {
      return {
        frameInfo: this.frameInfo, // this prop is used by Vue based modules
        hash: this.frameInfo.FrameID, // this prop and those below are used by legacy JS
        img: this.frameInfo.Urls.SmallWatermarked,
        orientation: (this.frameInfo.Orientation === 1) ? 'portrait' : 'landscape'
      }
    },
    numberRetouchingsApplied () {
      return this.frameInfo.RetouchingPackages.length + this.$store.getters.selectedRetouchingsByFrame(this.frameInfo.FrameID).length
    },
    content () {
      return this.$store.state.catalogPageCommon.selectPhotoModalContent
    },
    enhancementsModificationTitle () {
      return this.contentfulTextFormatted('enhancements-count', { numEnhancements: this.numberRetouchingsApplied })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/SelectPhotoModal/FrameImage.vue